import './LibraryHeader.css';

interface Props {
    eyebrow: string;
    title: string;
}

export function LibraryHeader({ eyebrow, title }: Props): React.JSX.Element {
    return (
        <div className="libraryHeader">
            <span className="libraryHeaderEyebrow">{eyebrow}</span>
            <h1 className="libraryHeaderTitle">{title}</h1>
        </div>
    );
}
